module.exports = __webpack_public_path__ + "static/6917-07780d02b7cd4d8383281458d6699100.jpg";